/* eslint-disable react/no-array-index-key */
import React from 'react'
import { useStoreState, useStoreActions } from 'easy-peasy'
import styled, { css } from 'styled-components'
import components from '../components/common'
import Intro from '../components/common/Intro'
import BtnAction from '../components/form/BtnAction'
import Modal from '../components/common/Modal'
import FootNote from '../components/common/FootNote'

const Container = styled.div`
  text-align: center;
  .styled-btn-action.paticipate {
    ${props =>
      props.locale === 'en-us' &&
      css`
        margin: 0 auto 0 !important;
      `}
  }
`

export default function Landing({ children }) {
  const [landing, locale] = useStoreState(state => [
    state.landing.landing,
    state.locale.locale,
  ])

  const { title, text, btn, footnote } = landing.intro
  const {
    marginBCont,
    marginTCont,
    titleColor,
    verticalPadding,
    titleFamily,
    fontFamily,
    textSize,
  } = landing.intro.config

  const [nextStep, setOpenModal] = useStoreActions(actions => [
    actions.steps.nextStep,
    actions.form.setOpenModal,
  ])

  const handleAction = () => {
    setOpenModal(true)
    nextStep()
  }

  return (
    <>
      {landing.firstComponents &&
        landing.firstComponents.map((item, i) => {
          const TypeComponent = components[item.type]
          return (
            <TypeComponent
              key={`component-${item.type}-${i}`}
              config={item.config}
            />
          )
        })}
      <Container className="col" locale={locale}>
        <Intro
          title={title}
          text={text}
          textSize={textSize}
          marginTCont={marginTCont}
          marginBCont={marginBCont}
          titleColor={titleColor}
          verticalPadding={verticalPadding}
          titleFamily={titleFamily}
          fontFamily={fontFamily}
        />
        <BtnAction
          id="participate"
          action={handleAction}
          btn={btn}
          className="paticipate"
        />
        {footnote && <FootNote footnote={footnote} />}
      </Container>
      <Modal config={landing.modalLeave}>{children}</Modal>
      {landing.lastComponents &&
        landing.lastComponents.map((item, i) => {
          const TypeComponent = components[item.type]
          return (
            <TypeComponent
              key={`component-${item.type}-${i}`}
              config={item.config}
            />
          )
        })}
    </>
  )
}
